import React from 'react';
import { Footer } from '../../../common/footer/footer';
import 'aos/dist/aos.css';
import Sidebar from "../sidebar/sidebar.js";

export const CustomerAskTheExpertJsx = (props) => {
  const {
    categoryData,
    handleEditRole,
    handleDeleteRole,
    handleAddRole
  } = props;

  return (
    <>
      <section className="entiredashboard admindashboard py-5 bg-light">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-lg-3 col-sm-12 mb-4">
              <div className="dashboardleftpanel p-3 bg-white shadow rounded">
                <Sidebar />
              </div>
            </div>

            {/* Main Content */}
            <div className="col-lg-9 col-sm-12">
              <div className="dashboardrightpanel p-4 bg-white shadow rounded">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h2 className="text-primary mb-0">Role Management</h2>
                  <button
                    onClick={handleAddRole}
                    className="btn btn-success px-4 py-2"
                  >
                    <i className="fas fa-plus me-2"></i>
                    Add New Role
                  </button>
                </div>

                <div className="expertsection">
                  {categoryData?.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-striped table-hover">
                        <thead className="table-dark">
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Role Name</th>
                            <th scope="col">Access Level</th>
                            <th scope="col">Permissions</th>
                            <th scope="col">Created Date</th>
                            <th scope="col">Status</th>
                            <th scope="col">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {categoryData.map((data, index) => (
                            <tr key={`role-${data.roleId || index}`}>
                              <td>{index + 1}</td>
                              <td>
                                <strong className="text-dark">{data?.roleName}</strong>
                              </td>
                              <td>
                                <span className="badge bg-info">
                                  {data?.access || 'Read/Write'}
                                </span>
                              </td>
                              <td>
                                <div className="permission-list">
                                  {data?.modules?.length > 0 ? (
                                    <span className="badge bg-secondary me-1">
                                      {data.modules.length} permissions
                                    </span>
                                  ) : (
                                    <span className="text-muted">No permissions</span>
                                  )}
                                </div>
                              </td>
                              <td>
                                <small className="text-muted">
                                  {data?.createdAt ? 
                                    new Date(data.createdAt).toLocaleDateString() : 
                                    'N/A'
                                  }
                                </small>
                              </td>
                              <td>
                                <span className={`badge ${data?.isActive !== false ? 'bg-success' : 'bg-danger'}`}>
                                  {data?.isActive !== false ? 'Active' : 'Inactive'}
                                </span>
                              </td>
                              <td>
                                <div className="btn-group" role="group">
                                  <button
                                    onClick={() => handleEditRole(data)}
                                    className="btn btn-outline-primary btn-sm"
                                    title="Edit Role"
                                  >
                                   Edit
                                  </button>
                                  <button
                                    onClick={() => handleDeleteRole(data.roleId)}
                                    className="btn btn-outline-danger btn-sm"
                                    title="Delete Role"
                                  >
                                   Delete
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <div className="mb-3">
                        <i className="fas fa-users-cog fa-3x text-muted"></i>
                      </div>
                      <h5 className="text-muted">No roles found</h5>
                      <p className="text-muted">Create your first role to get started</p>
                      <button
                        onClick={handleAddRole}
                        className="btn btn-primary"
                      >
                        Create First Role
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default CustomerAskTheExpertJsx;